import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { LanguageService } from "src/app/shared/services/language.service";
import { PrintDefinitionsService } from 'src/app/_api/services/print-definitions.service';
import { PrintersService } from 'src/app/_api/services/printers.service';
import CustomStore from 'devextreme/data/custom_store';
import { DxDataGridComponent } from "devextreme-angular";
import { confirm } from 'devextreme/ui/dialog';
import { UserService } from '../../../services/user.service';
import notify from 'devextreme/ui/notify';

let self: SettingsComponent = null;
@Component({
  selector: 'app-shared-printer-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  dataSource: CustomStore = null;
  printerDataSource: CustomStore = null;

  @ViewChild(DxDataGridComponent, { static: false }) gridComponent: DxDataGridComponent;

  @Input() parameters = null;

  constructor(public ls: LanguageService,
    private printersService: PrintersService,
    private printDefinitionsService: PrintDefinitionsService,
    private us: UserService) {
    self = this;
  }

  ngOnInit() {
  }

  setPrinterDataSource() {
    //HACK to delay the reading of unload config
    this.printerDataSource = new CustomStore({
      loadMode: 'raw',
      key: 'PrinterId',
      load() {
        return self.printersService.get().toPromise();
      }
    });

    this.dataSource = new CustomStore({
      loadMode: 'raw',
      key: 'PrintDefinitionId',
      load() {
        return self.printDefinitionsService.getByPrintTypeMethod(
          'bartender',
          self.parameters?.ClientIPAddress,
          self.parameters?.OperatorPanelToken,
          self.parameters?.Client).toPromise();
      },
      update: (printDefinitionId, changedData) => {
        return this.printDefinitionsService.addUserDefinedPrinter(
          printDefinitionId, changedData.EmployeeAssignedPrinterId, this.us.account.EmployeeId).toPromise();
      }
    });
  }

  onClickEditButton(e: any, cell: any, addUserDefinedPrinter: boolean) {
    if (addUserDefinedPrinter) {
      this.gridComponent.instance.editRow(cell.rowIndex);
    }
    else {
      const title = `${this.ls.LNG('Label.Button.Remove')} ${this.ls.LNG('Label.UserDefinedPrinter').toLowerCase()}`;
      const message = `${this.ls.LNG('Label.Button.Remove')} "${cell.data.Printers[0].Name}" ${this.ls.LNG('Label.From').toLowerCase()} ${this.ls.LNG('Label.Label').toLowerCase()} "${cell.data.Name}" ?`;
      const result = confirm(message, title);
      result.then((dialogResult) => {
        if (dialogResult) {
          this.printDefinitionsService.removeUserDefinedPrinter(cell.data.PrintDefinitionId, this.us.account.EmployeeId).toPromise().then(d => {
            this.onRefresh();
          }).catch(err => {
            notify(err, "error", 5000);
          });
        }
      });
    }
  }


  onClickAbortEditButton() {
    this.gridComponent.instance.cancelEditData();
  }


  onSaveClick(cell) {
    const sdf = this.gridComponent.instance.saveEditData().then(saved => {
      this.onRefresh();
    });
  }

  onRefresh() {
    if (this.gridComponent != null) {
      this.gridComponent.instance.cancelEditData();
      this.gridComponent.instance.refresh();
    }
  }

  onEditorPrepared(e) {
    const theCell = this.gridComponent.instance.getCellElement(e.row.rowIndex, "PrinterId");
    this.gridComponent.instance.focus(theCell);
  }

  onRowPrepared(e) {
    if (e.rowType === 'data') {
      e.rowElement.style.height = "50px";
    }
  }

}
